export default function search() {
    var $searchForm = $('#cw-search-form'),
        $searchInput = $('#query'),
        $jsSearch = $('.js-search-btn'),
        $helpSearch = $('.form--search'),
        $helpSearchInput = $('.js-search-help-input'),
        $jsModalDismiss = $('.js-modal-dismiss'),
        searchRequest;

    $searchForm.on('keyup', '#query', function (e) {
        clearTimeout(searchRequest);

        // Check input length
        var val = $(this).val().trim();
        val = val.replace(/\s+/g, '');

        if (val.length > 2) {
            searchRequest = setTimeout(function () {
                $.ajax({
                    type: "GET",
                    url: $('#cw-search-form').data('target'),
                    data: "query=" + val,
                    success: function (data) {
                        $('#modal-search__results').replaceWith(data);
                    }
                });
            }, 300);
        }
    });

    $searchForm.on('keydown', '#query', function (e) {
        if (e.which === 13) {
            e.preventDefault();
        }
    });

    $jsSearch.on('click', function() {
        $jsSearch.find('.icon').toggleClass('icon--search icon--close');
        $('body').toggleClass('overflow');
        $searchInput.val('');
    });

    $helpSearch.on('submit', function(e) {
        e.preventDefault();
        $jsSearch.find('.icon').toggleClass('icon--search icon--close');
        $('body').toggleClass('overflow');
        $("#modal-search").modal('show');
        $searchInput.val($helpSearchInput.val());
        $helpSearchInput.val('');
        $('.footer__help__icon--close').click();
        $searchInput.keyup();
    });

    $jsModalDismiss.on('click', function () {
        $('body').removeClass('overflow');
        $jsSearch.find('.icon').toggleClass('icon--search icon--close');
        $searchInput.val('');
    });
}



// WEBPACK FOOTER //
// ./src/Resources/ui/js/search.js